module.exports = __webpack_public_path__ + "static/img/feature3.fcde639b.jpg";